import { render, staticRenderFns } from "./Chart_Electrical_Spectrum.vue?vue&type=template&id=44a07450&scoped=true"
import script from "./Chart_Electrical_Spectrum.vue?vue&type=script&lang=js"
export * from "./Chart_Electrical_Spectrum.vue?vue&type=script&lang=js"
import style0 from "./Chart_Electrical_Spectrum.vue?vue&type=style&index=0&id=44a07450&prod&lang=css"
import style1 from "./Chart_Electrical_Spectrum.vue?vue&type=style&index=1&id=44a07450&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a07450",
  null
  
)

export default component.exports